import _defineProperty from "/Users/henri/Desktop/git/docteurphilipperoure/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/henri/Desktop/git/docteurphilipperoure/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/Users/henri/Desktop/git/docteurphilipperoure/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// src/Obfuscate.tsx
import { createElement, forwardRef, useCallback, useMemo, useState } from "react"; // src/util.ts

var noop = function noop() {};

var reverse = function reverse(content) {
  return content.split("").reverse().map(function (s) {
    if (s === "(") return ")";
    if (s === ")") return "(";
    if (s === "[") return "]";
    if (s === "]") return "[";
    if (s === "{") return "}";
    if (s === "}") return "{";
    if (s === "<") return ">";
    if (s === ">") return "<";
    return s;
  }).join("");
};

var isString = function isString(s) {
  return typeof s === "string";
};

var createUri = function createUri(_ref) {
  var email = _ref.email,
      tel = _ref.tel,
      sms = _ref.sms,
      href = _ref.href,
      children = _ref.children;

  if (email) {
    if (isString(email)) return "mailto:".concat(email);
    if (children) return "mailto:".concat(children);
  }

  if (tel) {
    if (isString(tel)) return "tel:".concat(tel.replace(/\s/g, ""));
    if (children) return "tel:".concat(children.replace(/\s/g, ""));
  }

  if (sms) {
    if (isString(sms)) return "sms:".concat(sms.replace(/\s/g, ""));
    if (children) return "sms:".concat(children.replace(/\s/g, ""));
  }

  if (href) return href;
  return void 0;
}; // src/Obfuscate.tsx


var Obfuscate = forwardRef(function Obfuscate2(_ref2, ref) {
  var _ref2$as = _ref2.as,
      as = _ref2$as === void 0 ? "a" : _ref2$as,
      email = _ref2.email,
      tel = _ref2.tel,
      sms = _ref2.sms,
      href = _ref2.href,
      children = _ref2.children,
      _ref2$ariaLabel = _ref2["aria-label"],
      ariaLabel = _ref2$ariaLabel === void 0 ? "focus to reveal obfuscated content" : _ref2$ariaLabel,
      _ref2$obfuscateText = _ref2.obfuscateText,
      obfuscateText = _ref2$obfuscateText === void 0 ? "obfuscated" : _ref2$obfuscateText,
      style = _ref2.style,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? noop : _ref2$onClick,
      _ref2$onFocus = _ref2.onFocus,
      onFocus = _ref2$onFocus === void 0 ? noop : _ref2$onFocus,
      _ref2$onMouseOver = _ref2.onMouseOver,
      onMouseOver = _ref2$onMouseOver === void 0 ? noop : _ref2$onMouseOver,
      _ref2$onContextMenu = _ref2.onContextMenu,
      onContextMenu = _ref2$onContextMenu === void 0 ? noop : _ref2$onContextMenu,
      rest = _objectWithoutProperties(_ref2, ["as", "email", "tel", "sms", "href", "children", "aria-label", "obfuscateText", "style", "onClick", "onFocus", "onMouseOver", "onContextMenu"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      humanInteraction = _useState2[0],
      setHumanInteraction = _useState2[1];

  var componentStyle = useMemo(function () {
    return _objectSpread(_objectSpread({}, style), {}, {
      unicodeBidi: "bidi-override",
      direction: humanInteraction ? "ltr" : "rtl"
    });
  }, [style, humanInteraction]);
  var content = useMemo(function () {
    if (children) return children;
    if (isString(email)) return email;
    if (isString(tel)) return tel;
    if (isString(sms)) return sms;
    if (isString(href)) return href;
    return "";
  }, [children, email, tel, sms, href]);
  var uri = useMemo(function () {
    return createUri({
      email: email,
      tel: tel,
      sms: sms,
      href: href,
      children: children
    });
  }, [email, tel, sms, href, children]);
  var hrefUri = useMemo(function () {
    return humanInteraction ? uri : obfuscateText;
  }, [humanInteraction, uri, obfuscateText]);
  var handleOnClick = useCallback(function (e) {
    onClick(e);

    if (!humanInteraction && uri) {
      window.location.href = uri;
    }
  }, [humanInteraction, uri, onClick]);
  var handleOnFocus = useCallback(function (e) {
    onFocus(e);
    setHumanInteraction(true);
  }, [onFocus]);
  var handleOnMouseOver = useCallback(function (e) {
    onMouseOver(e);
    setHumanInteraction(true);
  }, [onMouseOver]);
  var handleOnContextMenu = useCallback(function (e) {
    onContextMenu(e);
    setHumanInteraction(true);
  }, [onContextMenu]);
  return createElement(as, _objectSpread(_objectSpread({
    style: componentStyle,
    href: uri ? hrefUri : void 0,
    "aria-label": humanInteraction ? void 0 : ariaLabel,
    onClick: handleOnClick,
    onFocus: handleOnFocus,
    onMouseOver: handleOnMouseOver,
    onContextMenu: handleOnContextMenu
  }, rest), {}, {
    ref: ref
  }), humanInteraction ? content : reverse(content));
});
export { Obfuscate };